import { res } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
export default {
    async email(idx: number | null, data: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                `/report/report/mail`,
                {
                    idx: idx,
                    receiverMail: data.toEmail,
                    title: data.title,
                    content: data.content,
                },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async twitter(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                `/report/report/twitter`,
                {
                    idx,
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async youtube(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                `/report/report/youtube`,
                {
                    idx,
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async bluesky(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                `/report/report/bluesky`,
                {
                    idx,
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getDetail(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/report/report/detail/` + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },

    // backend 작업 완료되면 url 변경 예정 :: TODO :: sy
    async multiReport(idxList: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                `/report/multi/report/twitter`,
                {
                    idxList,
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
